<template>
  <layout-basic>
    <div class="section" id="order-list">
      <div class="level" style="margin-top: 35px">
        <div class="level-item is-narrow">
            <h2 class="title">List of orders</h2>
        </div>

        <div class="level-item is-narrow">
          <div class="buttons">
            <b-button type="is-primary" @click="$router.push('/order/create')" >New order</b-button>
          </div>
        </div>
      </div>

      <div class="table-container">
      <b-table
              :data="orders"
              :paginated="isPaginated"
              :per-page="perPage"
              :current-page.sync="currentPage"
              :pagination-simple="isPaginationSimple"
              :pagination-position="paginationPosition"
              :default-sort-direction="defaultSortDirection"
              :sort-icon="sortIcon"
              :sort-icon-size="sortIconSize"
              :hoverable="true"
              @click="orderRowClick"
              :striped="true"
              :selected.sync="selectedOrderRow"
              default-sort="order_date"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page">

        <template slot-scope="props">
          <b-table-column class="word-break-all" field="reference" label="Order reference" sortable>
            {{ props.row.reference }}
          </b-table-column>

          <b-table-column field="status" label="Status">
            {{ getOrderStateByCode(props.row.state) }}
          </b-table-column>

          <b-table-column field="order_date" label="Date created" sortable>
            {{ dateFormat(props.row.order_date)}}
          </b-table-column>
        </template>
      </b-table>
      </div>
    </div>

    <order-overview
            :isOrderOverViewModalActive="isOrderOverViewModalActive"
            :orderInfo="selectedOrderInfo"
            @close="orderOverviewClose"
            @updateOrdersList="getOrders"
    ></order-overview>
  </layout-basic>
</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'
import OrderOverview from '@/components/order-owerview/OrderOverview'
import Cloudprinter from '../services/CloudprinterService'
import Button from 'buefy'
import DateMixin from '@/mixins/DateMixin'
import router from '@/router'
import NotificationService from '@/services/NotificationService'

export default {
  name: 'OrderList',
  mixins: [DateMixin],
  components: {
    Button,
    LayoutBasic,
    OrderOverview
  },
  data () {
    return {
      selectedOrderRow: {},
      orders: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'desc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 20,
      isOrderOverViewModalActive: false,
      selectedOrderInfo: {}
    }
  },

  created () {
    // Get list of orders
    this.getOrders()

    // Order overview
    if (this.$route.params.reference) {
      let orderReference = this.$route.params.reference + this.$route.hash
      this.orderOverview(orderReference.replace('%20', ' '))
    }

    // Handle the Esc key press.
    document.addEventListener('keyup', event => {
      if (event.keyCode === 27) {
        this.orderOverviewClose()
      }
    })
  },

  methods: {
    getOrders: function () {
      this.$store.dispatch('loader/show')

      Cloudprinter.getOrders()
        .then((response) => {
          this.orders = response.data
        })
        .finally(() => {
          this.$store.dispatch('loader/hide')
        })
    },

    getOrderStateByCode: function (code) {
      let orderStatuses = {
        1: 'Order is new and not processed',
        5: 'Order is being verified',
        6: 'Order has been verified',
        7: 'Order verification error',
        10: 'Order files are being downloaded',
        11: 'Order files download error',
        15: 'Order files has been downloaded',
        30: 'Order is being rendered',
        31: 'Order render error',
        32: 'Order has been rendered',
        33: 'Order file is being distributed',
        34: 'Order file has been distributed',
        35: 'Order file distribute error',
        37: 'Order file is being created',
        38: 'Order file has been created',
        39: 'Order file create error',
        40: 'Order files are being uploaded',
        41: 'Order files upload error',
        42: 'Order waiting for upload accept',
        45: 'Order files has been uploaded',
        100: 'Order complete - All items in the order has been shipped or delivered',
        500: 'Order has been canceled',
        501: 'Sandbox order processing complete'
      }

      return orderStatuses[code]
    },

    orderRowClick: function (selectedRow) {
      this.orderOverview(selectedRow.reference)
    },

    orderOverview: function (orderReference) {
      this.$store.dispatch('loader/show')
      Cloudprinter.getOrder(orderReference).then(response => {
        this.selectedOrderInfo = response.data
        this.isOrderOverViewModalActive = true

        // Update the current window location path.
        const path = '/order/' + encodeURIComponent(orderReference)
        if (this.$route.path !== path) {
          this.$router.push(path)
        }
      }).catch(() => {
        NotificationService.warning('The order not found with reference - ' + orderReference)
      }).finally(() => {
        this.$store.dispatch('loader/hide')
      })
    },

    orderOverviewClose: function () {
      this.isOrderOverViewModalActive = false
      router.push('/orders')
    }
  }
}
</script>
